import apiInternal from './servers/apiInternal';

export interface PushCreateParams {
  cnjs: string[];
  makeDownload?: boolean;
  forced?: boolean;
  credentials?: {
    type: 'codilo' | 'aws';
    login: string;
    platform: string;
    codePlatform?: string;
    search?: string;
    key?: string;
  };
  tag?: string;
  ignore?: boolean;
}

export interface PushCreateResponse {
  success: boolean;
  data: {
    results: Array<{
      cnj: string;
      success: boolean;
      id: string;
      data: any;
    }>;
    errors: Array<{
      cnj: string;
      error: string;
    }>;
    total: number;
    successCount: number;
    errorCount: number;
  };
}

export interface PushDadosParams {
  cnjId: string;
  format?: string;
  order?: string;
}

export interface PushDadosResponse {
  success: boolean;
  data: any;
}

const pushPriority = {
  create: async (params: PushCreateParams): Promise<PushCreateResponse> => {
    const res = await apiInternal.post(`/push/novo`, params);
    return res.data;
  },
  getDados: async (params: PushDadosParams): Promise<PushDadosResponse> => {
    const { cnjId, format, order } = params;
    const queryParams = new URLSearchParams();
    if (format) queryParams.append('format', format);
    if (order) queryParams.append('order', order);
    const queryString = queryParams.toString();
    const url = `/push/dados/admin/${cnjId}${queryString ? `?${queryString}` : ''}`;
    const res = await apiInternal.get(url);
    return res.data;
  },
};

export default pushPriority;
